<script setup lang="tsx">
import methodEditor from '@/stores/method-editor'
import jiraCbStore from '@/stores/jira-checkboxes'
import { computed } from 'vue'
import IconButton from '@/components/shared/IconButton.vue'
import { hasPermission } from '@/services/utils'
import { PermAllMeasureWrite, PermOwnMeasureWrite } from '@/models/enums-generated'

const editor = methodEditor()
const jiraStore = jiraCbStore()

const isMassEditMode = computed(() => {
	return !editor.isEditMode && !jiraStore.isJiraMode
})

const canEditSelected = computed(() => {
	return editor.massEdit.selected.length
})
</script>

<template>
	<IconButton
		v-if="isMassEditMode && hasPermission(PermAllMeasureWrite, PermOwnMeasureWrite)"
		id="mass-edit-methods-btn"
		class="bi bi-pencil-square position-relative"
		:title="$t('massEdit.editSelected')"
		:count="editor.massEdit.selected.length"
		:disabled="!canEditSelected"
		@click="editor.massEdit.visible = true"
	/>
</template>
